export class Domicilio{
    public id_domicilio_pk:Number;
    public colonia:String;
    public calle: String;
    public num_ext:Number;
    public num_int:Number;
    public codigo_postal:Number;
    
}